export default __webpack_public_path__ + "static/media/Uppsala_logo.1016d150.png";